import { User } from './../../models/user';
import { CompanyService } from './../../services/company.service';
import { MembersComponent } from './../../layouts/members/members.component';
import { WeatherService } from './../../services/weather.service';
import { MenuItems } from './../../shared/menu-items/menu-items';
import { MessagingService } from './../../services/messaging.service';
import { UsersService } from './../../services/users.service';
import { SettingsService } from './../../services/settings.service';
import { Component, OnInit, OnDestroy, ViewChild, HostListener, AfterViewInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { GtMenuItems } from '../../shared/menu-items/gt-menu-items';
// import { MenuItems } from '../../shared/menu-items/menu-items';
import { Subscription } from 'rxjs/Subscription';
import { MdSnackBar } from '@angular/material';
import { AuthService } from '../../services/auth.service';
import { AvatarComponent } from '../../shared/avatar/avatar.component';
import 'rxjs/add/operator/map';


import { TranslateService } from '@ngx-translate/core';
import * as Ps from 'perfect-scrollbar';

@Component({
  selector: 'app-layout',
  templateUrl: './global-layout.component.html',
  styleUrls: ['./global-layout.component.scss'],
  providers: [MessagingService]
})
export class GlobalLayoutComponent implements OnInit, OnDestroy, AfterViewInit {
  private _router: Subscription;

  isLoggedIn:boolean;
  loggedInUser: User;
  logginUid: string;
  showRegister:boolean;
  currentCompany:any;
  today: number = Date.now();
  url: string;
  showSettings = false;
  dark: boolean;
  boxed: boolean;
  collapseSidebar: boolean = false;
  compactSidebar: boolean = false ;
  currentLang = 'en';
  filesToUpload: Array<File>;
  companies: any;
  messages: any;
  leftbar: boolean = true;
  weather:any;
  weekWeather:any;
  city:string = 'Paris,fr';
  wClass:any;
  wIcon:Array<{id:string,tran:string}> = [
  { id: '01d',tran : 'pe-is-w-sun-1'}, // clear sky
  { id: '01n',tran :'pe-is-w-moon-1'},
  { id: '02d',tran :'pe-is-w-partly-cloudy-1'},   // few clouds
  { id: '02n',tran :'pe-is-w-partly-cloudy-1'},
  { id: '03d',tran :'pe-is-w-mostly-cloudy-2'},
  { id: '03n',tran :'pe-is-w-mostly-cloudy-2'},
  { id: '04d',tran :'pe-is-w-wind-day'},
  { id: '04n',tran :'pe-is-w-wind-night'},
  { id: '09d',tran :'pe-is-w-heavy-hail-day'},
  { id: '09n',tran :'pe-is-w-heavy-hail-night'},
  { id: '10d',tran :'pe-is-w-heavy-rain-1'},
  { id: '10n',tran :'pe-is-w-heavy-rain-night'},
  { id: '11d',tran :'pe-is-w-thunderstorm-day-2'},
  { id: '11n',tran :'pe-is-w-thunderstorm-night-2'},
  { id: '13d',tran :'pe-is-w-snow'},
  { id: '13n',tran :'pe-is-w-snow'},
  { id: '50d',tran :'pe-is-w-fog-2'},
  { id: '50n',tran :'pe-is-w-fog-2'}
  ];

  members:any;

  @ViewChild('sidemenu') sidemenu;
  @ViewChild('root') root;
  @ViewChild('fileInput') fileInput;

  constructor(
    private router: Router,
    public menuItems: GtMenuItems,
    public translate: TranslateService,
    public snackBar:MdSnackBar,
    public authService:AuthService,
    public settingService: SettingsService,
    public userService: UsersService,
    public messagingService: MessagingService,
    public weatherService: WeatherService,
    public companyService: CompanyService,
     ) {
    const browserLang: string = translate.getBrowserLang();
    translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');


    this.settingService.getObsSettings()
      .subscribe(name => {
        if(name) this.currentCompany = name;
        this.companyService.getCompanyMembers(this.currentCompany.currentCompany).subscribe(members =>{
          this.members = members;
        });
      })
      this.filesToUpload = [];
    }

  ngOnInit(): void {


    this.authService.getUserDetails().subscribe(user => {
      if (user) {
        this.loggedInUser = user;
        this.logginUid = user.uid;
        this.isLoggedIn = true;
        this.userService.getUserCompanies(this.loggedInUser.uid).subscribe(companies => {
          this.companies = companies;
       })
       this.messagingService.getMessages(this.currentCompany.currentCompany,10).subscribe(res => {
        this.messages = res;
     })

      } else {
        this.router.navigate(['session/signin']);
      }
    })

 /*   this.authService.getAuth().subscribe(auth => {
      if(auth) {
        this.isLoggedIn = true;
        this.userService.getUserCompanies(auth.uid).subscribe(companies => {
          this.companies = companies;
       })
       this.messagingService.getMessages(this.currentCompany.currentCompany,10).subscribe(res => {
          this.messages = res;
       })
      } else {
        this.isLoggedIn = false;
      }
    });*/

    this.url = this.router.url;

    this._router = this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event: NavigationEnd) => {
      document.querySelector('.app-inner .mat-sidenav-content').scrollTop = 0;
      this.url = event.url;
      this.runOnRouteChange();
    });


    // ajout
    this.weatherService.getWeather(this.city).subscribe( w => {
      this.weather = w.json();
      this.wClass = this.findIconClass(this.weather.weather[0].icon);
      console.log(this.weather);
    });
  }

  findIconClass(id){
    return this.wIcon.find(x => x.id === id).tran;
  }


  changeCity(city){
     this.weatherService.getWeather(city).subscribe( w => {
     this.weather = w.json();
     this.wClass = this.findIconClass(this.weather.weather[0].icon);
  });

     this.weatherService.getWeekWeather(city).subscribe(wd=>{
     this.weekWeather = wd.json();
     console.log(this.weekWeather);
   });
}
// fin ajout

  ngAfterViewInit(): void  {
    this.root.dir = 'ltr';
    this.runOnRouteChange();
  }

  ngOnDestroy(): void  {
    this._router.unsubscribe();
  }

  runOnRouteChange(): void {
    if (this.isOver()) {
      if(this.sidemenu !== undefined){ this.sidemenu.close();}
    }

    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac() && !this.compactSidebar) {
      const elemContent = <HTMLElement>document.querySelector('.app-inner > .mat-sidenav-content');
      Ps.update(elemContent);
    }
  }

  isOver(): boolean {
    if (this.url === '/apps/messages' ||
      this.url === '/apps/calendar' ||
   //   this.url === '/apps/media' ||
      this.url === '/maps/leaflet' ||
      this.url === '/post' ||
      this.url === '/taskboard') {
      return true;
    } else {
      return window.matchMedia(`(max-width: 960px)`).matches;
    }
  }

 onLogoutClick(){
    this.settingService.clear();
    this.authService.logout();
    this.snackBar.open('Vous êtes déconnecté !','',{ duration : 1000 , extraClasses:['md-light-green-100'] });
    this.router.navigate(['session/signin']);
  }

  isMac(): boolean {
    let bool = false;
    if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
      bool = true;
    }
    return bool;
  }

  fileChangeEvent(fileInput: any){
    this.filesToUpload = <Array<File>> fileInput.target.files;
    console.log(this.filesToUpload);
  }

  onChangeCompany(k:string,cName:string){

    this.settingService.changeSettings({ currentCompany : k, currentCompanyName :cName });
  }

  upload() {
    let fileBrowser = this.fileInput.nativeElement;//.attributes.multiple;
    if (fileBrowser.files && fileBrowser.files[0]) {
      const formData = new FormData();
      formData.append("image", fileBrowser.files[0]);
    }
  }

}



// WEBPACK FOOTER //
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/src/app/layouts/global/global-layout.component.ts